import React, { createElement, useContext, useEffect } from "react";
import Components from "../components";
import classnames from "classnames";
import Image from "../Image/image";
import SbEditable from "storyblok-react";
import { format } from "date-fns";
import { PageContext } from "@/context/PageContext";
import Main from "@/components/Layout/main";
import styles from "./blog.module.scss";
import TextBlock from "@/components/TextBlock/text-block";
import FormNewsletter from "@/components/FormNewsletter/form-newsletter";
import { BlogStoryblok } from "@/types/component-types-sb";

interface Props {
  content: BlogStoryblok;
  name: string;
  published: string;
  className?: string;
  otherArticles?: any;
}

const BlogPost = (props: Props) => {
  const { data, setData } = useContext(PageContext);
  useEffect(() => {
    setData({ ...data, page_class: "blog" });
    return () => setData({ ...data, page_class: "" });
  }, []);

  const {
    content: { intro, body, article_image },
    name,
    published,
  } = props;

  const publishedDate =
    published && format(new Date(published), "MMMM d, yyyy");

  const introBlok = {
    text_style: "subtitle",
    content: intro,
    no_max_width: true,
  } as const;

  return (
    // @ts-expect-error
    <SbEditable content={props.content}>
      <Main className={styles.blogPost}>
        {article_image?.filename && article_image.filename !== "" && (
          <div className={styles.blogHero}>
            <Image
              filename={article_image.filename}
              alt={article_image.alt}
              focus={article_image.focus}
              aspectMobile={"1/1"}
              aspectDesktop={"16/9"}
              priority
            />
          </div>
        )}
        <div className={styles.blogTitle}>
          <p className={styles.blogPublished}>{publishedDate}</p>
          <h3 className="ef-h3 u-mb-0">{name}</h3>
        </div>
        <TextBlock
          {...introBlok}
          className={styles.blogContentItem}
          _uid=""
          component="text-block"
        />
        {body &&
          body.map((blok) => {
            return createElement(Components(blok.component), {
              blok,
              key: blok._uid,
              className: classnames(
                styles.blogContentItem,
                styles[blok.component]
              ),
            });
          })}
        <FormNewsletter />
      </Main>
    </SbEditable>
  );
};

export default BlogPost;
